import React from 'react';
import parse from 'html-react-parser';

/**
 * BannerSectionStyle7 — Used by DepartmentDetails page (centred, image above heading)
 */
export default function BannerSectionStyle7({
  imgUrl,
  bgUrl,
  title,
  subTitle,
}) {
  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-16">
      <div
        className="relative bg-cream-dark rounded-md overflow-hidden text-center flex flex-col items-center justify-end pt-12 pb-14 px-8 md:px-20"
        style={bgUrl ? { backgroundImage: `url(${bgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}
      >
        {bgUrl && <div className="absolute inset-0 bg-cream/85" />}

        {imgUrl && (
          <img
            src={imgUrl}
            alt="Banner"
            className="relative z-10 max-h-[220px] w-auto object-contain mb-8 drop-shadow-md"
          />
        )}

        <div className="relative z-10 max-w-[640px]">
          <div className="inline-flex items-center justify-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4">
            <span className="w-[24px] h-px bg-gold block" />
            Noohra Services
          </div>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.8rem] font-light leading-[1.2] text-charcoal mb-4">
            {parse(title || '')}
          </h2>
          {subTitle && (
            <p className="text-base leading-[1.75] text-mid font-light m-0">
              {parse(subTitle)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
